
import React, { useEffect, useRef, useState, useMemo } from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import { AgGridReact } from 'ag-grid-react';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import classnames from 'classnames';
import { fetchGridLayout, getDecoder, getHyphenDDMMMYYYYHHMM, saveGridLayout,statusMessages } from '../common/utils';
import ResendConsentRenderer from './ResendConsentRenderer.js'
import EditSimTracking from './editsimtracking.js'
import AttendedButtonRenderer from './AttendedButtonRenderer';
import redirectURL from "../redirectURL";
const SimTracking = () => {
    const gridColumnApi = useRef(null)
    const savedRef = useRef(null)
    const user = useMemo(() => getDecoder(), []);
    const [sweetAlert, setSweetAlert] = useState({
        type: null,
        title: '',
        show: false
    });
    const [searchMobileNo, setSearchMobileNo] = useState('');
    const [slider, setSlider] = useState({
        sliderTranslate: '',
        overly: "show-n"
    })
    const [sliderText, setSliderText] = useState("")
    const [rowData, setRowData] = useState([])
    const [driverName, setDriverName] = useState('')
    const [driverMobile, setDriverMobile] = useState("")
    const [assignedTruckNo, setAssignedTruckNo] = useState('')
    const [rowid, setRowId] = useState('')
    const [errMsg, setErrMsg] = useState('')
    const [loading, setLoading] = useState({
        loadshow: 'show-n',
        overly: 'show-n'
    })
    const [loadshow,setLoadShow] = useState('show-n')
    const [activeTab, setActiveTab] = useState('1')
    const [simActivationSearchMobileNo, setSimActivationSearchMobileNo] = useState('')
    const [simActivationRowData, setSimActivationRowData] = useState([])
    const [simActivationLoadShow, setSimActivationLoadShow] = useState('show-n')
    const defaultColDef = useMemo(() => {
        return {
            sortable: true,
            filter: true,
            autoSizeColumns: true,
            resizable: true,
            pivot: true,
        }
    });
    const columnwithDefs = useMemo(() => {
        return [
            {
                headerName: "Driver Name",
                field: "driver_name",
                width: 120,
            },
            {
                headerName: "Driver Mobile No",
                field: "driver_mobile_no",
                width:120
            },
            {
                headerName: "SIM Consent Status",
                field: "consent_status",
                width: 128,
                valueGetter:function(params){
                            try{
                                if(params?.data?.consent_status != "")
                                {
                                    let word = params?.data?.consent_status;
                                    word = word.charAt(0).toUpperCase() + word.slice(1);
                                    return word;
                                }
                            }
                            catch(e){}
                    }
 
            },
            {
                headerName: "Latitude",
                field: "latitude",
                width: 120,
            },
            {
                headerName: "Longitude",
                field: "longitude",
                width: 120,
            },
            {
                headerName: "Location Status",
                field: "location_status",
                width: 150,
            },
            {
                headerName: "Location Status Remarks",
                field: "location_status_text",
                width: 150,
            },
            {
                headerName: "Service Provider Name",
                field: "service_provider_name",
                width: 120,
            },
            {
                headerName: "Created Date",
                field: "created_date",
                width: 170,
                valueGetter: function (params) {
                    try {
                        return !["",undefined,null].includes(params.data.created_date) ? getHyphenDDMMMYYYYHHMM(params.data.created_date) : ''
                    }
                    catch (e) {

                    }
                },
                editable: false
            },
            {
                headerName: "Server Time",
                field: "server_time",
                width: 170,
                valueGetter: function (params) {
                    try {
                        return !["",undefined,null].includes(params.data.server_time) ? getHyphenDDMMMYYYYHHMM(params.data.server_time) : ''
                    }
                    catch (e) {

                    }
                },
                editable: false
            },
            {
                headerName: "Jio Consent Status",
                field: "jio_consent_status",
                width: 150,
            },
            {
                headerName: "Jio Consent Status Updated On",
                field: "jio_consent_status_updated_on",
                width: 170,
                valueGetter: function (params) {
                    try {
                        return !["",undefined,null].includes(params.data.jio_consent_status_updated_on) ? getHyphenDDMMMYYYYHHMM(params.data.jio_consent_status_updated_on) : ''
                    }
                    catch (e) {

                    }
                },
                editable: false
            },
            {
                headerName: "Operator",
                field: "operator",
                width: 120,
            },
            {
                headerName: "Active",
                field: "active",
                width: 120,
                valueGetter:function(params){
                            try{
                                if(params?.data?.active != "")
                                {
                                    let word = params?.data?.active === true?"True":"False"
                                    return word;
                                }
                                else{
                                    return "False";
                                }
                            }
                            catch(e){}
                    }
            },
            {
                headerName: "Charged",
                field: "charged",
                width: 120,
                valueGetter:function(params){
                            try{
                                if(params?.data?.charged != "")
                                {
                                    let word = (params?.data?.charged != "" && params?.data?.charged === true)?"True":"False"
                                    return word;
                                }
                                else{
                                    return "False";
                                }
                            }
                            catch(e){}
                    }
            },
            {
                headerName: "Suspended",
                field: "suspended",
                width: 130,
                valueGetter:function(params){
                            try{
                                if(params?.data?.suspended != "")
                                {
                                    let word = params?.data?.suspended === true?"True":"False"
                                    return word;
                                }
                                else{
                                    return "False";
                                }
                            }
                            catch(e){}
                    }
            },
            {
                headerName: "Tracked",
                field: "tracked",
                width: 120,
                valueGetter:function(params){
                            try{
                                if(params?.data?.tracked != "")
                                {
                                    let word = params?.data?.tracked === true?"True":"False"
                                    return word;
                                }
                                else{
                                    return "False";
                                }
                            }
                            catch(e){}
                    }
            },
            {
                headerName: "MSISDN",
                field: "msisdn",
                width: 120,
            },
            {
                headerName: "Modified Date",
                field: "modified_date",
                width: 170,
                valueGetter: function (params) {
                    try {
                        return !["",undefined,null].includes(params.data.modified_date) ? getHyphenDDMMMYYYYHHMM(params.data.modified_date) : ''
                    }
                    catch (e) {

                    }
                },
                editable: false
            },


        ]
    }, []);
    const simActivationColumnDefs = useMemo(() => {
        return [
            {
                headerName: "FO Number",
                field: "fo_number",
                width: 150,
            },
            {
                headerName: "Mobile Number",
                field: "mobile_no",
                width: 150,
            },
            {
                headerName: "Activation Request Date",
                field: "activation_request_date",
                width: 200,
                valueGetter: function (params) {
                    try {
                        return !["", undefined, null].includes(params.data.activation_request_date) ? getHyphenDDMMMYYYYHHMM(params.data.activation_request_date) : ''
                    }
                    catch (e) {

                    }
                },
            },
            {
                headerName: "Activation Date",
                field: "activated_time",
                width: 200,
                valueGetter: function (params) {
                    try {
                        return !["", undefined, null].includes(params.data.activated_time) ? getHyphenDDMMMYYYYHHMM(params.data.activated_time) : ''
                    }
                    catch (e) {

                    }
                },
            },
            {
                headerName: "Enabled Date",
                field: "enabled_time",
                width: 200,
                valueGetter: function (params) {
                    try {
                        return !["", undefined, null].includes(params.data.enabled_time) ? getHyphenDDMMMYYYYHHMM(params.data.enabled_time) : ''
                    }
                    catch (e) {

                    }
                },
            },
        ]
    }, []);
    useEffect(() => {
        loadData()
    }, [])
    const saveGrid = async (e) => {
        let coloumnState = gridColumnApi.current.api?.getColumnState()
        savedRef.current = coloumnState
        if (user != "" && user?.email != undefined) {
            let temp = await saveGridLayout(user?.email, "simtracking", coloumnState)
            if (temp.data.status == "success") {
                setSweetAlert({
                    show: true,
                    type: 'success',
                    title: 'Grid Saved Successfully'
                })
            }
            else {
                setSweetAlert({
                    show:true,
                    type:'danger',
                    title:"Failed to Save grid"
                })
            }
        }
    }
    const resetGrid = async () => {
        let coloumnState = []
        if (user != "" && user.email != undefined) {
            let temp = await saveGridLayout(user?.email, "simtracking", coloumnState)
            if (temp.data.status == "success") {
                setSweetAlert({
                    type:'success',
                    show:true,
                    title:'Grid successfully reset'
                })
                gridColumnApi.current.api.resetColumnState()
            }
            else {
                setSweetAlert({					
                    show: true,
                    basicTitle: "Failed to reset grid",
                    basicType: "danger"
                });
            }
        }
    }
    const onSearchMobileNo = async (event) => {
        if (!!searchMobileNo) {
            setLoadShow("show-m")
            await redirectURL.post('/getSimLatestTrackingLocation', { driver_mobile_no: searchMobileNo } )
                .then((response) => {
                    setRowData(response?.data?.records ?? [])
                    setLoadShow("show-n")
                })
                .catch(function (error) {
                    return error
                })
        }
    }
    const loadData = async () => {
        let params = {}
        setLoadShow("show-m")
        await redirectURL.post("/getSimLatestTrackingLocation", params)
            .then(async (resp) => {
                if (resp.data?.status == 'success') {
                    setRowData(resp.data?.records)
                    setLoadShow("show-n")
                }
                else {
                    setLoadShow("show-n")
                    setRowData([])
                }
        })
    }
    const loadSimActivationLogs = async (mobileNo) => {
        setSimActivationLoadShow("show-m")
        let params = {}
        if (!!mobileNo) {
            params.driver_mobile_no = mobileNo
        }
        await redirectURL.post("/getSimActivationTraceLogs", params)
            .then((resp) => {
                if (resp.data?.status == 'success') {
                    setSimActivationRowData(resp.data?.records ?? [])
                }
                else {
                    setSimActivationRowData([])
                    setSweetAlert({
                        show: true,
                        type: 'danger',
                        title: 'Failed to fetch SIM Activation Logs. Please try again later.'
                    })
                }
                setSimActivationLoadShow("show-n")
            })
            .catch(function (error) {
                setSimActivationRowData([])
                setSimActivationLoadShow("show-n")
                setSweetAlert({
                    show: true,
                    type: 'danger',
                    title: 'Failed to fetch SIM Activation Logs. Please try again later.'
                })
            })
    }
    const toggleTab = (tab) => {
        if (activeTab !== tab) {
            setActiveTab(tab)
            if (tab === '2') {
                loadSimActivationLogs(simActivationSearchMobileNo)
            }
        }
    }
    const onSearchSimActivationMobileNo = () => {
        loadSimActivationLogs(simActivationSearchMobileNo)
    }
    const onResetSimActivationSearch = () => {
        setSimActivationSearchMobileNo('')
        loadSimActivationLogs('')
    }
    const onConfirm = () => {
        setSweetAlert({
            type: "",
            show: false,
            title: ''
        })
        if(sweetAlert?.title== 'Grid Saved Successfully')
        setTimeout(async () => {
                await gridColumnApi.current.api.applyColumnState({
                    state: savedRef.current,
                    applyOrder: true,
                })
            }, 1000);
    }
    const onCLickAddDriver = (e) => {
        setSlider({
            sliderTranslate: 'slider-translate',
            overly: 'show-m'
        })
        !!e.target ? setSliderText("Add Driver") : setSliderText("Edit Driver")
        !!e.data &&
        setDriverName(e.data?.driver_name)
        setDriverMobile(e.data?.driver_mobile_no)
        setAssignedTruckNo(e.data?.assigned_truck_no)
        setRowId(e.data?._id)
    }
    const changeMobileNoHandler = (e) => {
        const value = e.target.value.replace(/[^0-9]/g, "");;
        const regex = /^[6-9][0-9]{0,9}$/; // starts with 6–9, up to 10 digits
        if (value === "" || regex.test(value)) {
            setDriverMobile(value); // ✅ store actual number
        }
    };
    const changeVehicleNo = (e) => {
        let value = e.target.value;
        value = value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
        setAssignedTruckNo(value)
    }
    const mobileValidation = (e) => {
            (driverMobile.length < 10) ?
            setErrMsg("Invalid Mobile Number") : setErrMsg('')
    }
    const saveDriver = (e) => {
        e.preventDefault();
        var params = {
            driver_name: driverName,
            mobile_no: driverMobile,
            assigned_truck_no: assignedTruckNo,
        }
        if (sliderText == 'Add Driver') {
            redirectURL.post("/adddriver", params)
                .then((response) => {
                    if (response.data.status === "Success") {
                        setSweetAlert({
                            show: true,
                            type: "success",
                            title: "Driver Added Successfully"
                        })
                    }
                    else {
                        setSweetAlert({
                            show: true,
                            type: "danger",
                            title: response.data.message
                        })
                    }
                    loadData()
                })
        }
        else if (sliderText == 'Edit Driver') {
            params.rowid = rowid
            redirectURL.post("/updatedriver", params).then((response) => {
                if (response.data.status == 'success') {
                    setSweetAlert({
                        type: 'success',
                        show: true,
                        title: 'Driver Updated Successfully'
                    })
                }
                else {
                    setSweetAlert({
                        show: true,
                        type: 'danger',
                        title: 'Failed to Update '
                    })
                }
                loadData()
            })
        }
        setSlider({
            setSlider: "",
            sliderText: ""
        })
    }
    const onCellClicked = async (params) => {
        if (params.colDef.field === "resend") {
            setLoading({
                loadshow: 'show-m',
                overly: "show-m"
            })
            let param = params.data
            redirectURL.post("/resendconsent", param).then((response) => {
                if (response.data.status == 'Success') {
                    setSweetAlert({
                        show: true,
                        title: response?.data?.message,
                        type: 'success'
                    })
                    setLoading({
                        overly: 'show-n',
                        loadshow: 'show-n'
                    })
                    loadData()
                }
                else {
                    setSweetAlert({
                        show: true,
                        title: response.data.message,
                        type: 'danger'
                    })
                    setLoading({
                        overly: 'show-n',
                        loadshow: 'show-n'
                    })
                }
            })
        }
        if (params.colDef.field == "verified") {
            setLoading({
                overly: 'show-m',
                loadshow: "show-m"
            })
            redirectURL.post("/verifyconsent", params.data).then((response) => {
                if (response.data.message === "Success") {
                    setLoading({
                        loadshow: 'show-n',
                        overly: 'show-n'
                    })
                    setSweetAlert({
                        show: true,
                        title: response.data.message,
                        type: 'success'
                    })
                    loadData();
                }
                else {
                    setLoading({
                        overly: 'show-n',
                        loadshow: 'show-n'
                    })
                    setSweetAlert({
                        show: true,
                        title: response.data.message,
                        type: 'danger'
                    })
                }
            })
        }
    }
    const onCloseModal = async (params) => {
        setSlider({
            sliderTranslate: '',
            sliderText: ''
        })
        setDriverName('')
        setDriverMobile('')
        setAssignedTruckNo('')
    }
    return (
        <>
            <div className='container-fluid'>
                <SweetAlert
                    show={sweetAlert?.show}
                    type={sweetAlert?.type}
                    title={sweetAlert?.title}
                    onConfirm={onConfirm}>
                </SweetAlert>
                <div className="col-xl-12 col-lg-12" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <h5 style={{ margin: 0 }}>
                        <i className="icofont icofont-vehicle-delivery-van cus-i"></i> <span>Telenity API</span>
                    </h5>
                </div>
                <br />
                <div className="row">
                    <div className="col-xl-12 col-lg-12" >
                        <Nav tabs>
                            <NavItem>
                                <NavLink
                                    className={classnames({ active: activeTab === '1' })}
                                    onClick={() => toggleTab('1')}
                                    style={{ cursor: "pointer" }}
                                >
                                    Telenity Location Status
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={classnames({ active: activeTab === '2' })}
                                    onClick={() => toggleTab('2')}
                                    style={{ cursor: "pointer" }}
                                >
                                    SIM Activation Logs
                                </NavLink>
                            </NavItem>
                        </Nav>
                        <TabContent activeTab={activeTab}>
                            <TabPane tabId="1">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="col4 mb-3" style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                            <span>Mobile No.</span>
                                            <input type="text" value={searchMobileNo} maxLength={10} onChange={e => setSearchMobileNo(isNaN(parseInt(e.target.value)) ? "" : parseInt(e.target.value))} autoComplete="off" class="form-control" style={{ width: "200px" }}></input>
                                            <button type="button" onClick={onSearchMobileNo} className="btn btn-success">Search</button>
                                            <button type="button" onClick={e => window.location.reload()} className="btn btn-warning">Reset</button>
                                        </div>
                                        <div id="dynamic-grid" style={{ height: "550px", width: "100%" }} className="ag-theme-balham">
                                            <AgGridReact
                                                ref={gridColumnApi}
                                                columnDefs={columnwithDefs}
                                                defaultColDef={defaultColDef}
                                                frameworkComponents={{ attendedButtonRenderer: AttendedButtonRenderer }}
                                                paginationPageSize={500}
                                                pagination={true}
                                                rowData={rowData}
                                                stopEditingWhenGridLosesFocus={true}
                                                suppressCellFlash={true}
                                                context={{ componentParent: { onCLickAddDriver } }}
                                                onCellClicked={onCellClicked}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </TabPane>
                            <TabPane tabId="2">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="col4 mb-3" style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                            <span>Mobile No.</span>
                                            <input type="text" value={simActivationSearchMobileNo} maxLength={10} onChange={e => setSimActivationSearchMobileNo(isNaN(parseInt(e.target.value)) ? "" : parseInt(e.target.value))} autoComplete="off" class="form-control" style={{ width: "200px" }}></input>
                                            <button type="button" onClick={onSearchSimActivationMobileNo} className="btn btn-success">Search</button>
                                            <button type="button" onClick={onResetSimActivationSearch} className="btn btn-warning">Reset</button>
                                        </div>
                                        <div id="dynamic-grid-sim-activation" style={{ height: "550px", width: "100%" }} className="ag-theme-balham">
                                            <AgGridReact
                                                columnDefs={simActivationColumnDefs}
                                                defaultColDef={defaultColDef}
                                                paginationPageSize={500}
                                                pagination={true}
                                                rowData={simActivationRowData}
                                                suppressCellFlash={true}
                                                overlayNoRowsTemplate="No Records Found"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </TabPane>
                        </TabContent>
                    </div>
                </div>
                <div className={"dataLoadpage " + (loadshow === "show-m" || simActivationLoadShow === "show-m" ? "show-m" : "show-n")}></div>
                <div className={"dataLoadpageimg " + (loadshow === "show-m" || simActivationLoadShow === "show-m" ? "show-m" : "show-n")} style={{ top: "21em" }}>
                    <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
                </div>
            </div>
        </>
    )
}

export default SimTracking
